import { ValidationGenerator } from "../../../form/validation/validation-generator"
import { UserValidationSetting } from "../../../form/validation/validation-setting"
import { User } from "../../../rpcs/dist/UserRPC"

export type IFormField = Pick<User, "screenName" | "email" | "description">

export const validate = (values: Partial<IFormField>) => {
  const errors: Partial<IFormField> = {}

  const UserScreenNameVal = ValidationGenerator(
    values.screenName,
    UserValidationSetting.screenName,
  )

  const UserEmailVal = ValidationGenerator(values.email, {
    ...UserValidationSetting.email,
    isRequired: false,
  })

  const UserDescriptionVal = ValidationGenerator(
    values.description,
    UserValidationSetting.description,
  )

  if (UserScreenNameVal) {
    errors.screenName = UserScreenNameVal
  }

  if (UserEmailVal) {
    errors.email = UserEmailVal
  }

  if (UserDescriptionVal) {
    errors.description = UserDescriptionVal
  }

  return errors
}
